var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"image"},[(_vm.$slots.image && _vm.image)?_vm._t("image"):_vm._e(),(_vm.$slots.loader && _vm.loader)?_vm._t("loader"):_vm._e(),(_vm.$slots.error && _vm.error)?_vm._t("error"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }